<div class="heading" *ngIf="pageConfig">
  <span class="heading-main">
    <span
      class="heading-back"
      (click)="navigate('login')"
      *ngIf="isBackButton"></span>
    {{ pageConfig.heading }}
  </span>
  <span class="heading-sec heading-sec-top">
    <span class="heading-sec-one" [ngStyle]="getColor()">{{ pageConfig.subheading1 }}</span>
    <span
      class="heading-sec-two tertiary-button"
      (click)="navigate(pageConfig.subheading2)"
      >{{ pageConfig.subheading2 }}</span
    >
  </span>
</div>
